import { defineStore } from 'pinia';
import { BusinessKey } from '../types/store';
import { parseJwt } from '../utils';
import { cloneDeep } from 'lodash';

type BusinessState = Partial<{
  userInfo: any;
  token: string;
  businessId: string;
  business: any;
  businesses: any[];
  userLoggedIn: boolean;
  notifications: any[];
  listener: any;
  ref: any;
  redirectionId: string;
  benefit_assignation: string;
  isPaymentLink: boolean;
  paymentLinkUrl: string;
}>;

export const STORE_KEY = 'businessStore';

const defaultState: BusinessState = {
  userInfo: null,
  token: '',
  businessId: '',
  business: null,
  businesses: [],
  userLoggedIn: false,
  notifications: [],
  listener: null,
  ref: null,
  redirectionId: '',
  benefit_assignation: '',
  isPaymentLink: false,
  paymentLinkUrl: '',
};

export const useGlobalStore = defineStore(STORE_KEY, {
  state: (): BusinessState => ({...cloneDeep(defaultState)}),
  actions: {
    setUserInfo(_userInfo: any) {
      this.userInfo = {..._userInfo};
    },
    setToken(_token: string) {
      this.token = _token;
    },
    setBusinessId(_businessId: string) {
      this.businessId = _businessId;
    },
    setBusiness(_business: any) {
      this.business = {..._business};
    },
    setBusinesses(_businesses: any[]) {
      this.businesses = [..._businesses];
    },
    setUserLoggedIn(_userLoggedIn: boolean) {
      this.userLoggedIn = _userLoggedIn;
    },
    setNotifications(_notifications: any[]) {
      this.notifications = [..._notifications];
    },
    setListener(_listener: any) {
      if(!this.listener)
        this.listener = _listener;
    },
    setRef(_ref: any) {
      if(!this.ref)
        this.ref = _ref;
    },
    setRedirectionId(_redirectionId: string){
      this.redirectionId = _redirectionId;
    },
    setBenefitAssignation(_benefit_assignation: string) {
      this.benefit_assignation = _benefit_assignation;
    },
    setPaymentLinkUrl(_paymentLinkUrl: string) {
      this.paymentLinkUrl = _paymentLinkUrl;
    },
    setIsPaymentLink(_isPaymentLink: boolean) {
      this.isPaymentLink = _isPaymentLink;
    },
    reset() {
      const defaultStateData = cloneDeep(defaultState);
      this.userInfo = defaultStateData.userInfo;
      this.token = defaultStateData.token;
      this.businessId = defaultStateData.businessId;
      this.business = defaultStateData.business;
      this.businesses = defaultStateData.businesses;
      this.userLoggedIn = defaultStateData.userLoggedIn;
      this.notifications = defaultStateData.notifications;
      this.redirectionId = defaultStateData.redirectionId;
      this.ref = defaultStateData.ref;
    },
    resetPaymentLink() {
      const defaultStateData = cloneDeep(defaultState);
      this.isPaymentLink = defaultStateData.isPaymentLink;
      this.paymentLinkUrl = defaultStateData.paymentLinkUrl;
    },
    setLoggedInDataWithToken(_token: string) {
      if(!_token) {
        this.reset();
        return;
      }

      this.setToken(_token);

      const userInfo = parseJwt(_token);
      this.setUserInfo(userInfo);

      this.setUserLoggedIn(true);
    },
  },
  persist: {
    enabled: true,
    strategies: [
      {
        storage: BusinessKey,
        key: STORE_KEY,
        paths: ['token', 'businessId', 'business', 'userLoggedIn', 'businesses', 'userInfo', 'ref', 'listener', 'notifications', 'redirectionId', 'benefit_assignation', 'isPaymentLink', 'paymentLinkUrl']
      }
    ],
  },
});
